'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ExportGuideModal } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/export-guide-modal/export-guide-modal.component';
import { Appointment } from '@/types/appointments.types';
import { useModal } from '@/hooks/use-modal.hook';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface AppointmentCardExportGuideProps {
  appointment: Appointment;
}

export function AppointmentCardExportGuide({ appointment }: AppointmentCardExportGuideProps) {
  const { open, onOpen, onOpenChange } = useModal();
  const analytics = getAnalyticsPlugin();

  const handleOpenModal = () => {
    analytics.track(AnalyticsEnum.MY_APPOINTMENTS_CLICK_EXPORT_GUIDE, {
      tipo_agendamento: appointment.type,
      status_agendamento: appointment.status,
    });
    onOpen();
  };

  return (
    <>
      <button
        type="button"
        aria-label="Exportar guia"
        data-testid={DataTestIdEnum.APPOINTMENT_CARD_EXPORT_GUIDE}
        className="text-green-500 font-semibold text-sm whitespace-nowrap"
        onClick={handleOpenModal}
      >
        Exportar guia
      </button>

      <ExportGuideModal
        open={open}
        onOpenChange={onOpenChange}
        appointment={appointment}
      />
    </>
  );
}
